import { MODAL_OPEN, MODAL_TOGGLE, MODAL_CLOSE } from '../types';

export const toggleModal = name => ({ type: MODAL_TOGGLE, payload: name });

export const openModal = name => ({ type: MODAL_OPEN, payload: name });

export const closeModal = () => ({ type: MODAL_CLOSE });
